import AppButton from '../../../../components/ui/AppButton';

const TabButton = ({ isActive, onClick, children }) => {
  return (
    <AppButton
      variant="text"
      onClick={onClick}
      sx={{
        marginRight: '10px',
        padding: '8px 10px',
        fontSize: '1.25rem',
        backgroundColor: isActive ? '#005773' : 'white',
        color: isActive ? 'white' : '#005773',
        border: '2px solid #005773',
        cursor: 'pointer',
        borderRadius: '4px',

        '&:hover': {
          backgroundColor: isActive ? '#005773' : 'white',
          color: isActive ? 'white' : '#005773',
        },
      }}
    >
      {children}
    </AppButton>
  );
};

export default TabButton;
